import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PublicModalView from "./PublicModalView";
import {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import axios from "axios";
import ReadIcon from "../assets/read-icon.png";
import SharePost from "./sharePost/SharePost";
import JobModal from "../pages/jobs/JobModal";
// import useOnlineStatus from "../hooks/useOnlineStatus";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ResearchSuggestionDropdown = forwardRef((props, ref) => {
  const {
    profileImage,
    last_seen_display,
    online_status,
    userName,
    description,
    heading,
    articleDate,
    reads,
    creations,
    journal,
    author,
    resumeImage,
    ButtonText,
    researcherCount,
    follow,
    type,
    jobData,
    post_type,
    mediaPreview,
    bodyDescription,
    postUrl,
    userProfileLink,
    showFollow,
    onFollowToggle,
    isFollowing,
    onProfileClick,
    postId,
    authorId,
    currentUserId,
    currentUser,
    onEditJob,
    is_Liked,
    likeCount,
    title,
    abstract,
    showExternalLink = true,
    disableNavigation = false,
    hideUserInfo = false,
    hideReads = false,
    latest_comment,
    showBackButton = false,
    commentCount,
    isInModal = false,
    onReadsUpdate,
  } = props;
  const navigate = useNavigate();
  const modalRef = useRef(null);
  console.log("the type is:",profileImage)
  console.log("ResearchSuggestionDropdown profileImage:",likeCount);


  // Parse type if it's a URL
  const getActualType = () => {
    if (!type) return "";
    
    // If type is a URL like "/post/97?type=image", extract the type parameter
    if (type.includes("?type=")) {
      try {
        const url = new URL(type, window.location.origin);
        return url.searchParams.get("type") || type;
      } catch {
        return type;
      }
    }
    return type;
  };

  const actualType = getActualType();
  //  const { onlineUsers } = useOnlineStatus(); // <-- here you get it
  //  console.log("The onlineUsers is:",onlineUsers,currentUser?.user)
  // const isOnline = onlineUsers.has(currentUser?.user?.toString());
  // console.log("Original type:", type);
  // console.log("Actual type:", actualType);
  // console.log("commentCount in research is:", commentCount);
  // console.log("commentCount in research is:",commentCount)
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const [editText, setEditText] = useState(
    actualType === "post" ? title || "" : bodyDescription || ""
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [creating, setCreating] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [commentText, setCommentText] = useState("");
  const [showCommentBox, setShowCommentBox] = useState(isInModal);
  const [comments, setComments] = useState([]);
  const [isLiked, setIsLiked] = useState(!!is_Liked);
  const [likedCount, setLikedCount] = useState(likeCount ?? 0);
  // console.log("the liked couunt is :",likedCount)
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [postOwner, setPostOwner] = useState(null);
  const commentsEndRef = useRef(null);
  const [editingCommentId, setEditingCommentId] = useState(null);
  const [commentCounter, setCommentCounter] = useState(commentCount ?? 0);
  const [editComment, setEditingComment] = useState("");
  const [editVisibility, setEditVisibility] = useState("public");
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [following, setFollowing] = useState([]);
  const [inviteLoading, setInviteLoading] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
  const [collaboratorsLoading, setCollaboratorsLoading] = useState(false);
  const [receivedInvitations, setReceivedInvitations] = useState([]);
  const [showShareModal, setShowShareModal] = useState(false);
  const [editingJob, setEditingJob] = useState(null);
  const [jobFormData, setJobFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [posts, setPosts] = useState([]);
  const token = localStorage.getItem("access_token");
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState(null);
  // console.log("Component mounted");
  const [bodyDescriptionState, setBodyDescriptionState] = useState(
    bodyDescription || ""
  );

  const fetchPosts = async () => {
    // console.log("fetchPosts called");
    try {
      const res = await axios.get(`${BASE_URL}/user/posts/`, {
        headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY },
      });
      setPosts(res.data.results);
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };

  // useEffect(() => {
  //   if (token) {
  //     fetchPosts();
  //   }
  // }, [token]);

  const handleEditJob = () => {
    if (!jobData) return;
    setEditingJob(jobData);
    setJobFormData({
      id: jobData.id || "",
      title: jobData.title || "",
      job_title: jobData.job_title || "",
      company_name: jobData.company_name || "",
      content: jobData.content || "",
      location: jobData.location || "",
      remote_allowed: jobData.remote_allowed || false,
      salary_min: jobData.salary_min || "",
      salary_max: jobData.salary_max || "",
      currency: jobData.currency || "USD",
      experience_level: jobData.experience_level || "",
      job_type: jobData.job_type || "",
      skills_required: jobData.skills_required || "",
      qualifications: jobData.qualifications || "",
      application_email: jobData.application_email || "",
      application_url: jobData.application_url || "",
    });
    setIsAddModalOpen(true);
  };

  useImperativeHandle(ref, () => ({
    handleEditJob,
  }));

  const handleJobChange = (e) => {
    const { name, value, type, checked } = e.target;
    setJobFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSaveJobEdit = async () => {
    try {
      setCreating(true);
      const payload = { ...jobFormData, post_type: "job" };

      const url = `${BASE_URL}/user/posts/`;

      const res = await fetch(url, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Failed to update job");

      const updatedJob = await res.json();
      console.log("Updated Job:", updatedJob);

      setIsAddModalOpen(false);
      setEditingJob(null);
      fetchPosts();
    } catch (error) {
      console.error(error);
    } finally {
      setCreating(false);
    }
  };

  const handleEditComment = (comment) => {
    setEditingCommentId(comment.id);
    setEditingComment(comment.text);
  };

  const saveEditComment = async (id) => {
    try {
      await axios.patch(
        `${BASE_URL}/user/comment/`,
        { id, commit: editComment },
        { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
      );
      setEditingCommentId(null);
      fetchComments();
    } catch (error) {
      console.error("Error editing comment:", error);
      toast.error("Failed to edit comment");
    }
  };

  const handleDeleteComment = async (commentId) => {
    try {
      await axios.delete(`${BASE_URL}/user/comment/`, {
        data: { id: commentId },
        headers: { Authorization: `Bearer ${token}` ,"x-api-key": process.env.REACT_APP_X_API_KEY},
      });
      fetchComments();
      toast.success("Comment deleted");
    } catch (error) {
      console.error("Error deleting comment:", error);
      toast.error("Failed to delete comment");
    }
  };

  const fetchFollowing = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/user/follow-unfollow/follow/`, {
        headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY },
      });

      if (res.status === 200) {
        return res.data.results.map((item) => item.follow_user_profile);
      }
    } catch (error) {
      console.error("Error fetching following list:", error);
      return [];
    }
  };
// Whenever likeCount prop changes, update likedCount state
// Add this right after line 74
// Sync likes when props change in modal
useEffect(() => {
  if (isInModal) {
    setIsLiked(!!is_Liked);
    setLikedCount(likeCount);
    console.log('like count',likedCount)
  }
}, [isInModal, is_Liked, likeCount]);
  useEffect(() => {
    const loadFollowing = async () => {
      const users = await fetchFollowing();
      setFollowing(users);
    };
    loadFollowing();
  }, []);

  const handleInviteCollaborator = async (collaboratorId) => {
    try {
      setInviteLoading(true);
      const formData = new FormData();
      formData.append("collebrate_user", collaboratorId);
      formData.append("publication_id", postId);

      const res = await axios.post(
        `${BASE_URL}/user/publication/add-collebrate-user/`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } ,"x-api-key": process.env.REACT_APP_X_API_KEY}
      );

      toast.success(res.data?.message || "Collaborator added successfully!");
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message ||
        "Something went wrong while inviting collaborator."
      );
    }
  };

  const handleDeletePost = async () => {
    try {
      if (!actualType || !postId) {
        toast.error("Missing post type or ID");
        return;
      }
      let url;
      if (actualType === "image") url = `${BASE_URL}/user/gallery/gallery-images/`;
      else if (actualType === "video") url = `${BASE_URL}/user/videos/video/`;
      else if (actualType === "code") url = `${BASE_URL}/user/code/code/`;
      else if (actualType === "post") url = `${BASE_URL}/user/posts/`;
      else if (actualType === "publication")
        url = `${BASE_URL}/user/publication/publication/`;
      else if (actualType === "internship")
        url = `${BASE_URL}/user/internship/internship/`;
      else {
        toast.error("Unknown post type");
        return;
      }
      const token = localStorage.getItem("access_token");
      const formData = new FormData();
      formData.append("id", postId);
      setLoading(true);
      await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
        data: formData,
      });
      toast.success("Post deleted successfully");
      setIsVisible(false);
    } catch (error) {
      console.error("Error deleting post:", error.response || error);
      toast.error("Failed to delete post");
    } finally {
      setLoading(false);
    }
  };
  const handleSaveEdit = async () => {
    try {
      if (!actualType || !postId) {
        toast.error("Missing post type or ID");
        return;
      }
      if(!editText)
      {
        toast.error("Title is required");
        return;
      }
      let url;
      if (actualType === "image") url = `${BASE_URL}/user/gallery/gallery-images/`;
      else if (actualType === "video") url = `${BASE_URL}/user/videos/video/`;
      else if (actualType === "code") url = `${BASE_URL}/user/code/code/`;
      else if (actualType === "post") url = `${BASE_URL}/user/posts/`;
      else if (actualType === "publication")
        url = `${BASE_URL}/user/publication/publication/`;
      else {
        toast.error("Unknown post type");
        return;
      }
      const token = localStorage.getItem("access_token");
      const formData = new FormData();
      formData.append("id", postId);
      formData.append("title", editText);
      formData.append("visibility", editVisibility);

      setLoading(true);
      await axios.patch(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "x-api-key": process.env.REACT_APP_X_API_KEY
        },
      });
      toast.success("Post updated successfully");
      setBodyDescriptionState(editText);
      setIsEditing(false);
    } catch (error) {
      console.error("Error editing post:", error.response || error);
      toast.error("Failed to update post");
    } finally {
      setLoading(false);
    }
  };

  const handleLike = async () => {
    try {
      const res = await axios.post(
        `${BASE_URL}/user/like/`,
        { type: actualType, id: postId },
        { headers: { Authorization: `Bearer ${token}`, "x-api-key": process.env.REACT_APP_X_API_KEY } }
      );

      if (res.data?.status) {
        const liked = res.data.status === "liked";
        setIsLiked(liked);
        setLikedCount((prev) => (liked ? prev + 1 : prev - 1));
      }
    } catch (error) {
      console.error("Error liking post:", error);
    }
  };

  const handleComment = async () => {
    try {
      setLoading(true);
      await axios.post(
        `${BASE_URL}/user/comment/`,
        { type: actualType, id: postId, commit: commentText },
        { headers: { Authorization: `Bearer ${token}`,"x-api-key": process.env.REACT_APP_X_API_KEY } }
      );
      setCommentText("");
      fetchComments();
      setCommentCounter((prev) => prev + 1);
    } catch (error) {
      console.error("Error posting comment:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleContainerClick = (e) => {
    if (disableNavigation) return;

    if (isEditing || isAddModalOpen) return;

    if (e.target.closest(".dropdown-menu")) return;

    if (postUrl) {
      window.history.pushState({}, "", postUrl);
      setModalType(postUrl); // ✅ pass type here

      // Optimistically update reads in the parent list so the UI reflects the view count immediately
      if (onReadsUpdate && postId) {
        onReadsUpdate(postId, (reads || 0) + 1);
      }

      setOpen(true); // ✅ open modal
    }
  };

  const fetchComments = async () => {
    try {
      setCommentLoading(true);
      const res = await axios.get(`${BASE_URL}/user/comment/`, {
        params: { type: actualType, id: postId },
        headers: { Authorization: `Bearer ${token}` ,"x-api-key": process.env.REACT_APP_X_API_KEY},
      });

      if (res.data?.results) {
        const mappedComments = res.data.results.map((c) => ({
          id: c.id,
          author: c.user.name,
          avatar: c.user.profile_picture,
          text: c.text,
          userId: c.user.id,
        }));
        setComments(mappedComments);
        setPostOwner(res.data.post_owner);
        setCommentCounter(mappedComments.length);
      }
    } catch (error) {
      console.error("Error fetching comments:", error);
    } finally {
      setCommentLoading(false);
    }
  };

  <div
    className="comments-box"
    style={{ maxHeight: "200px", overflowY: "auto" }}
  >
    {comments.map((c) => (
      <div key={c.id}>{/* comment content */}</div>
    ))}
    <div ref={commentsEndRef} />
  </div>;

  const canUserEdit = () => {
    if (!currentUserId) return false;

    //Owner can always edit
    if (Number(authorId) === Number(currentUserId)) return true;
    //Only publications can have editable collaborators
    if (actualType !== "publication") return false;

    // Collaborator with can_edit
    return receivedInvitations.some(
      (inv) =>
        String(inv.publication) === String(postId) &&
        String(inv.user) === String(currentUser.user) &&
        inv.can_edit
    );
  };
  const canEdit = canUserEdit();

  // Sync commentCount prop
  useEffect(() => {
    console.log("Syncing commentCount prop:", commentCount);
    if (commentCount !== undefined) {
      setCommentCounter(commentCount);
    }
  }, [commentCount]);

  // Fetch comments when component mounts in modal
  useEffect(() => {
    if (isInModal && postId && actualType) {
      console.log("Modal opened, fetching comments for post:", postId, "type:", actualType);
      fetchComments();
    }
  }, [isInModal, postId, actualType]);

  useEffect(() => {
    if (showCommentBox) {
      fetchComments();
    }
  }, [postId, actualType, showCommentBox]);

  useEffect(() => {
    const storedUser = localStorage.getItem("currentUser");
    if (storedUser) {
      setLoggedInUser(JSON.parse(storedUser));
    }
  }, []);



  if (!isVisible) return null;

  return (
    
  <>
  <div className="mb-4 border border-gray-200 rounded-2xl bg-white shadow-sm hover:shadow-md transition-all duration-200">
  <div
    className="p-6 w-full cursor-pointer"
    onClick={handleContainerClick}
  >
    <div className="flex flex-col">
      {!hideUserInfo && (
        <div className="flex-1">
          <div
            className="flex items-center gap-4 justify-between mb-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div
              className="flex items-center gap-3"
              onClick={onProfileClick}
            >
              <div className="relative">
                <img 
                  src={profileImage} 
                  alt="User" 
                  className="w-12 h-12 rounded-xl object-cover border-2 border-white shadow-sm" 
                />
                <div
  className={`absolute -bottom-1 -right-1 w-3 h-3 rounded-full border-2 border-white ${
  online_status ? 'bg-green-500' : 'bg-gray-400'
  }`}
/>

              </div>
              <div className="flex flex-col">
                <span className="font-semibold text-gray-900">{userName}</span>
                <span className="text-sm text-gray-500">{articleDate}</span>
                {author && (
                  <span className="text-xs text-gray-600 mt-0.5">
                    By <strong>{author}</strong>
                  </span>
                )}
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              {canEdit && (
                <div
                  className="relative"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdownOpen(!dropdownOpen);
                    }}
                  >
                    <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
                    </svg>
                  </button>

                  {dropdownOpen && (
                    <div className="absolute right-0 top-full mt-1 bg-white rounded-xl shadow-lg border border-gray-200 py-1 z-10 w-36">
                      <button
                        className="flex items-center gap-2 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 w-full transition-colors"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (post_type === "job") {
                            if (onEditJob) {
                              onEditJob(jobData);
                            } else {
                              handleEditJob();
                            }
                          } else {
                            setIsEditing(true);
                          }
                          setDropdownOpen(false);
                        }}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                        </svg>
                        Edit
                      </button>
                      <button
                        className="flex items-center gap-2 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 w-full transition-colors"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeletePost();
                          setDropdownOpen(false);
                        }}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                        </svg>
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              )}
              
              {showFollow && !isFollowing && (
                <button 
                  className="px-4 py-2 text-sm font-medium rounded-xl border-2 border-[#0f6abf] text-[#0f6abf] hover:bg-[#0f6abf] hover:text-white transition-colors"
                  onClick={onFollowToggle}
                >
                  Follow
                </button>
              )}
            </div>
          </div>

          {!isEditing ? (
            <>
              {type === "post" ? (
                <div className="text-sm text-gray-800 leading-relaxed whitespace-pre-line mb-4 bg-gray-50 rounded-xl p-4">
                  {title}
                </div>
              ) : (
                <>
                 <div className="text-lg text-gray-900 mb-2">
  {expanded || bodyDescriptionState.length <= 120
    ? bodyDescriptionState
    : bodyDescriptionState.slice(0, 120) + "..."}

  {bodyDescriptionState.length > 120 && (
    <span
      onClick={() => setExpanded(!expanded)}
      className="text-blue-600 cursor-pointer ml-1"
    >
      {expanded ? " Read less" : " Read more"}
    </span>
  )}
</div>

                  {/* <div className="text-sm text-gray-700 leading-relaxed whitespace-pre-line mb-4  rounded-xl p-4">
                    {title}
                  </div> */}
                </>
              )}
            </>
          ) : (
            <div className="mt-3 p-5 bg-gray-50 rounded-xl border border-gray-200">
              <textarea
                className="w-full p-4 bg-white border border-gray-300 rounded-xl text-sm leading-normal resize-none outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
                value={editText}
                onChange={(e) => setEditText(e.target.value)}
                rows="4"
                placeholder="Add a description..."
              />
              {type === "publication" && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">Sharing Options</label>
                  <select
                    className="w-full p-3 border border-gray-300 rounded-xl text-sm  focus:outline-none transition-colors"
                    value={editVisibility}
                    onChange={(e) => setEditVisibility(e.target.value)}
                  >
                    <option value="public">Public</option>
                    <option value="private">Private</option>
                  </select>
                </div>
              )}
              <div className="flex gap-3 mt-4">
                <button
                  className="flex-1 py-2.5 px-4 border border-gray-300 rounded-xl text-sm font-medium hover:bg-gray-100 transition-colors"
                  onClick={() => setIsEditing(false)}
                >
                  Cancel
                </button>
                <button
                  className="flex-1 py-2.5 px-4 bg-[#0f6abf] text-white rounded-xl font-medium hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
                  onClick={handleSaveEdit}
                  disabled={loading}
                >
                  {loading ? (
                    <div className="flex items-center justify-center gap-2">
                      <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                      Saving...
                    </div>
                  ) : (
                    "Save Changes"
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      )}
      
      <div className="w-full mt-4">
        
        {mediaPreview ? (
          <div className="p-2 w-full overflow-hidden rounded-xl">
            {mediaPreview}
          </div>
        ) : (
          <img src={resumeImage} alt="resume" className="rounded-xl"/>
        )}
      </div>
    </div>

    {/* Action Buttons */}
    <div className="flex justify-between items-center mt-6 pt-6 border-t border-gray-100">
      <div className="flex gap-4">
        <button
          className={`flex items-center gap-2 px-0 md:px-3 py-2 rounded-xl transition-colors ${
            isLiked 
              ? "text-red-500 bg-red-50" 
              : "text-gray-600 hover:bg-gray-100"
          }`}
          onClick={(e) => {
            e.stopPropagation();
            handleLike();
          }}
        >
          <svg className="w-5 h-5" fill={isLiked ? "currentColor" : "none"} stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={isLiked ? "0" : "2"} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
          <span className="text-sm font-medium">
            {likedCount} {likedCount === 1 ? "Like" : "Likes"}
          </span>
        </button>

        <button
          className="flex items-center gap-2 px-0 md:px-3 py-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            setShowCommentBox((prev) => !prev);
          }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
          <span className="text-sm font-medium">
            Comments <span className="text-gray-500">({commentCounter})</span>
          </span>
        </button>

        {!hideReads && (
          <div className="flex items-center gap-2 px-0 md:px-3 py-2 text-gray-600">
            <img className="w-5 h-5" src={ReadIcon} alt="Read Icon" />
            <span className="text-sm font-medium">{reads}</span>
          </div>
        )}

        <button
          className="flex items-center gap-2 px-0 md:px-3 py-2 rounded-xl text-gray-600 hover:bg-gray-100 transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            setShowShareModal(true);
          }}
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
          </svg>
          <span className="text-sm font-medium">Share</span>
        </button>
      </div>
    </div>

    {showShareModal && (
      <SharePost
        postId={postId}
        postLink={type}
        onClose={() => setShowShareModal(false)}
      />
    )}

    {/* Job Modal */}
    {type === "post" && post_type === "job" && editingJob && (
      <JobModal
        isOpen={isAddModalOpen}
        onClose={() => setIsAddModalOpen(false)}
        formData={jobFormData}
        onChange={handleJobChange}
        onSave={handleSaveJobEdit}
        creating={creating}
        editingJob={true}
        formErrors={formErrors}
        ref={modalRef}
      />
    )}

    {/* Comments Section */}
    {showCommentBox && (
      <div
        className="mt-6 pt-6 border-t border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-4">
          <h4 className="font-medium text-gray-900 mb-3">Comments ({commentCounter})</h4>
          <div className="space-y-3 max-h-60 overflow-y-auto pr-2">
            {comments.length === 0 ? (
              <div className="text-center py-4">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-2">
                  <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <p className="text-sm text-gray-500">No comments yet</p>
              </div>
            ) : (
              comments.map((c) => (
                <div className="flex items-start gap-3" key={c.id}>
                  <img
                    src={c.avatar || currentUser?.profile_picture}
                    alt="User"
                    className="w-9 h-9 rounded-full object-cover border border-gray-200"
                    onClick={()=>navigate(`${currentUser?.id === c.userId ? "/profile-view" : `/user-profile/${c.userId}`}`)}
                  />
                  <div className="flex-1">
                    <div className="bg-gray-50 rounded-xl p-3">
                      <div className="flex items-center justify-between mb-1">
                        <span className="font-medium text-sm text-gray-900">{c.author}</span>
                        {(currentUser?.id === c.userId || postOwner === currentUser?.id) && (
                          <div className="flex gap-1">
                            {currentUser?.id === c.userId && (
                              <button
                                className="p-1 text-gray-400 hover:text-gray-600"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEditComment(c);
                                }}
                              >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                              </button>
                            )}
                            {(currentUser?.id === c.userId || postOwner === currentUser?.id) && (
                              <button
                                className="p-1 text-gray-400 hover:text-red-500"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteComment(c.id);
                                }}
                              >
                                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                      {editingCommentId === c.id ? (
                        <div className="mt-2">
                          <input
                            className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:outline-none"
                            type="text"
                            value={editComment}
                            onChange={(e) => setEditingComment(e.target.value)}
                          />
                          <div className="flex gap-2 mt-2">
                            <button 
                              className="px-3 py-1 bg-[#0f6abf] text-white text-sm rounded-lg"
                              onClick={() => saveEditComment(c.id)}
                            >
                              Save
                            </button>
                            <button 
                              className="px-3 py-1 bg-gray-200 text-gray-700 text-sm rounded-lg"
                              onClick={() => setEditingCommentId(null)}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <p className="text-sm text-gray-700">{c.text}</p>
                      )}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          <div ref={commentsEndRef} />
        </div>

        {/* Comment Input */}
        <div className="flex items-center gap-3">
          <img
            src={currentUser?.profile_picture}
            alt="Me"
            className="w-9 h-9 rounded-full object-cover border border-gray-200"
            onClick={()=>navigate("/profile-view")}
          />
          <form
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleComment();
            }}
            className="flex-1 flex gap-2"
          >
            <input
              className="flex-1 px-4 py-2.5 border border-gray-300 rounded-full text-sm focus:outline-none focus:border-[#0f6abf] focus:ring-1 focus:ring-[#0f6abf]/20 transition-colors"
              type="text"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              placeholder="Write a comment..."
            />
            <button 
              className="px-5 py-2.5 bg-[#0f6abf] text-white text-sm font-medium rounded-full hover:bg-[#0a5ca8] transition-colors disabled:opacity-50"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <div className="flex items-center gap-2">
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  Posting...
                </div>
              ) : (
                "Post"
              )}
            </button>
          </form>
        </div>
      </div>
    )}
  </div>
 {open && modalType && (
  <PublicModalView
    key={modalType}   // forces remount when post changes
    open={open}
    setOpen={setOpen}
    type={modalType}
    onReadsUpdate={onReadsUpdate}
  />
)}

</div>

{/* Invite Modal */}
{showInviteModal && (
  <div
    className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
    onClick={() => setShowInviteModal(false)}
  >
    <div className="bg-white rounded-2xl p-6 w-full max-w-md max-h-[80%] flex flex-col" onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-gray-900">Select a collaborator</h3>
      </div>

      <div className="flex-1 overflow-y-auto mb-4">
        {following.length === 0 ? (
          <div className="text-center py-8">
            <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
              </svg>
            </div>
            <p className="text-gray-500">You are not following anyone.</p>
          </div>
        ) : (
          <div className="space-y-2">
            {following.map((user) => (
              <div
                key={user.id}
                onClick={() => {
                  handleInviteCollaborator(user.id);
                  setShowInviteModal(false);
                }}
                className="flex items-center gap-3 p-3 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors"
              >
                <img
                  src={user.profile_picture}
                  alt={user.name}
                  className="w-10 h-10 rounded-lg object-cover border border-gray-200"
                />
                <span className="font-medium text-gray-900">{user.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <button
        className="w-full py-3 border border-gray-300 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors"
        onClick={() => setShowInviteModal(false)}
      >
        Cancel
      </button>
    </div>
  </div>
)}
  </>
  );
});

// export default ResearchSuggestionDropdown;
export default React.memo(ResearchSuggestionDropdown)

